@if (tagsVisible()) {
  <rt-candidate-tags-typeahead-wrapper
    [tags]="tags"
    [limitItems]="true"
    [withEmptyState]="withEmptyState()"
    [createIconButtonVariant]="'tertiary'"
    [showMoreButtonVariant]="'tertiary'"
    (save)="saveTag($event.value)"
    (delete)="deleteTag($event.value)"
  >
    <div heading layout layout-flex-1-0>
      <rt-icon name="tag-text-outline" colorToken="colorIconLowDefault" margin-right-small-xx />

      <rt-heading variant="subheading" padding-right-small>
        {{ 'app.common.tags' | translate }}
      </rt-heading>
    </div>
  </rt-candidate-tags-typeahead-wrapper>
}
